"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const prop_types_1 = __importDefault(require("prop-types"));
const themeColors_1 = require("../../theme/themeColors");
const prop_types_utils_1 = require("../../utils/prop-types-utils");
require("../../styles/components/line-progress-bar.less");
const { totangoGreen } = themeColors_1.themeColors;
const OVERALL_WIDTH = 270;
const getLineWidth = (progress, width) => (progress > 1 ? width : Math.floor(progress * width));
const LineProgressBar = ({ className, progress, width, height, color }) => (react_1.default.createElement("div", { className: (0, classnames_1.default)('line-progress-bar', className), style: { width, height } },
    react_1.default.createElement("span", { className: "completed", style: { width: getLineWidth(progress, width), height, backgroundColor: color } })));
LineProgressBar.defaultProps = {
    className: '',
    progress: 0,
    width: OVERALL_WIDTH,
    height: 12,
    color: totangoGreen,
};
LineProgressBar.propTypes = {
    className: prop_types_1.default.string,
    progress: (0, prop_types_utils_1.numberBetween)(0, 1),
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    color: prop_types_utils_1.isColor,
};
exports.default = LineProgressBar;
//# sourceMappingURL=line-progress-bar.js.map